// Mobile-only menu items - Hide on desktop (TARGET HEADER ONLY)
(function() {
  function hideMobileOnlyMenuItems() {
    console.log('[WTK Mobile Menu] Running, viewport width:', window.innerWidth);
    
    // Only run on desktop (viewport >= 990px)
    if (window.innerWidth < 990) {
      console.log('[WTK Mobile Menu] Mobile viewport detected, skipping hide');
      return;
    }
    
    console.log('[WTK Mobile Menu] Desktop viewport detected, looking for HEADER menu items only...');
    
    // CRITICAL FIX: Only find links inside header/nav elements, NOT dropdown tiles
    // Target specific header containers, not the entire page
    const headerContainers = document.querySelectorAll('header, nav.header__menu, .header__menu-list, header-drawer');
    
    const allLinks = [];
    headerContainers.forEach(container => {
      const galleryLinks = container.querySelectorAll('a[href*="custom-wheel-gallery"]');
      const quoteLinks = container.querySelectorAll('a[href*="custom-wheel-quote"]');
      
      galleryLinks.forEach(link => {
        // Double-check: skip if inside dropdown
        if (!link.closest('.wtk-brands-dropdown')) {
          allLinks.push(link);
        }
      });
      
      quoteLinks.forEach(link => {
        // Double-check: skip if inside dropdown
        if (!link.closest('.wtk-brands-dropdown')) {
          allLinks.push(link);
        }
      });
    });
    
    console.log('[WTK Mobile Menu] Found header menu links to hide:', allLinks.length);
    
    allLinks.forEach((link, index) => {
      console.log('[WTK Mobile Menu] Hiding header link ' + (index + 1) + ':', link.href, link.textContent);
      
      // Hide the link itself - VERY AGGRESSIVELY
      link.style.display = 'none';
      link.style.visibility = 'hidden';
      link.style.opacity = '0';
      link.style.position = 'absolute';
      link.style.left = '-99999px';
      link.style.height = '0';
      link.style.width = '0';
      link.style.overflow = 'hidden';
      link.setAttribute('aria-hidden', 'true');
      
      // Hide parent list item if it exists
      let parent = link.closest('li');
      if (parent) {
        console.log('[WTK Mobile Menu] Hiding parent <li>');
        parent.style.display = 'none';
        parent.style.visibility = 'hidden';
        parent.style.opacity = '0';
        parent.setAttribute('aria-hidden', 'true');
      }
      
      // Also hide parent details element (for accordion menus)
      let details = link.closest('details');
      if (details) {
        console.log('[WTK Mobile Menu] Hiding parent <details>');
        details.style.display = 'none';
        details.setAttribute('aria-hidden', 'true');
      }
    });
    
    console.log('[WTK Mobile Menu] Hiding complete');
  }
  
  // Run immediately
  hideMobileOnlyMenuItems();
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('[WTK Mobile Menu] DOMContentLoaded event fired');
      hideMobileOnlyMenuItems();
    });
  }
  
  // Run after a short delay to catch late-rendered elements
  setTimeout(function() {
    console.log('[WTK Mobile Menu] Running delayed check (500ms)');
    hideMobileOnlyMenuItems();
  }, 500);
  
  setTimeout(function() {
    console.log('[WTK Mobile Menu] Running delayed check (1500ms)');
    hideMobileOnlyMenuItems();
  }, 1500);
  
  // Re-run on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      console.log('[WTK Mobile Menu] Resize detected');
      hideMobileOnlyMenuItems();
    }, 250);
  });
  
  console.log('[WTK Mobile Menu] Script initialized');
})();
